module.exports = __webpack_public_path__ + "img/logo.e9499de9.png";